import styled from 'styled-components';

const BlogIndividualStyle = styled.section`
	.contentWrapper {
		p {
			padding-top: 0.1px;
			margin-bottom: var(--sp2x);
		}

		h4 {
			margin-top: var(--sp6x);
			margin-bottom: var(--sp2x);
		}

		ul {
			margin: var(--sp2-5x) 0 var(--sp4x);

			li {
				margin-bottom: var(--sp1x);
			}
		}

		.imageWrap {
			margin: var(--sp2x) 0 var(--sp4x) 0;
		}

		.Author {
			margin-top: var(--sp6x);

			p {
				display: inline-block;
				margin-bottom: 0;
			}
		}
	}

	.title {
		margin-bottom: var(--sp8x);
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.contentWrapper {
			margin-left: auto;
			margin-right: auto;

			ul {
				margin-left: var(--sp4x);
				margin: var(--sp4x) 0 var(--sp4x) var(--sp4x);
			}
		}
		.blogSingleCont {
			position: relative;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.contentWrapper {
			max-width: 70%;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		.contentWrapper {
			max-width: 72%;
		}

		.title {
			margin-bottom: var(--sp10x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		.contentWrapper {
			max-width: calc(100 * var(--sp1x));
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		.title {
			margin-bottom: var(--sp12x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		.title {
			margin-bottom: var(--sp12x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		.title {
			margin-bottom: var(--sp14x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		.contentWrapper {
			h4 {
				margin-top: var(--sp8x);
				margin-bottom: var(--sp3x);
			}

			ul {
				margin: var(--sp5x) 0 var(--sp5x) var(--sp5x);

				li {
					margin-bottom: var(--sp2x);
				}
			}
		}
		.title {
			margin-bottom: var(--sp19x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		.contentWrapper {
			p {
				margin-bottom: var(--sp5x);
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		.contentWrapper {
			max-width: calc(112 * var(--sp1x));

			ul {
				margin: var(--sp8x) 0 var(--sp8x) var(--sp8x);

				li {
					margin-bottom: var(--sp2-5x);
				}
			}

			.Author {
				margin-left: calc(var(--sp4x) * -1);
				margin-top: var(--sp8x);
			}
		}

		.title {
			margin-bottom: var(--sp20x);
		}
	}
`;

export default BlogIndividualStyle;
